<template>
  <div id="main">
    <h1>Vaše zajednice</h1>
    <data-table
      @row-click="handleRowClick"
      :columns="tableColumns"
      :tableData="tableData"
      :options="tableOptions"
      :slotNameCommunityName="'name'"
    ></data-table>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table.vue';
import { mapState, mapActions, mapMutations } from 'vuex';

/*
 * home view of application. it is consisted of
 * communities of manager.
 *
 * */
export default {
  components: {
    DataTable
  },
  computed: {
    /*
     * mapping vuex tableModule state
     * so we can pass it to table.vue component*/
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  created() {
    this.initTable('homeCommunitiesTable');
    import('@/util/notificationService.js');
  },
  destroyed() {},
  methods: {
    ...mapMutations(['setActiveCommunity']),
    ...mapActions('table', ['initTable']),
    handleRowClick(e) {
      this.setActiveCommunity(e.row.id);
      this.$router.push({
        name: 'community',
        params: {
          id: e.row.id
        }
      });
    }
  }
};
</script>

<style scoped>
#main {
  padding: 0px 10px;
  padding-top: 50px;
}
h1 {
  text-align: center;
  padding-bottom: 20px;
}
</style>
